import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Compass } from "lucide-react";

const Loader = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#0B0F17]">
    <div className="flex flex-col items-center gap-4">
      <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-cyan-400 to-indigo-500 flex items-center justify-center animate-pulse">
        <Compass className="h-6 w-6 text-[#041016]" />
      </div>
      <span className="font-mono-data text-xs uppercase tracking-[0.3em] text-cyan-400">Loading</span>
    </div>
  </div>
);

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) return <Loader />;
  if (!user) return <Navigate to="/auth" state={{ from: location }} replace />;
  if (roles && !roles.includes(user.role))
    return <Navigate to="/dashboard" replace />;
  return children;
}
